import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Panel, PanelType } from 'office-ui-fabric-react/lib/Panel';
import { Redirect } from 'react-router-dom';
import { DetailsList, SelectionMode, Selection, ConstrainMode } from 'office-ui-fabric-react/lib/DetailsList';
import { MessageBars } from '../Outils/MessageBars';
import { DefaultButton, PrimaryButton, IconButton } from 'office-ui-fabric-react/lib/Button';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { Sticky, StickyPositionType } from 'office-ui-fabric-react/lib/Sticky';
import { TooltipHost } from 'office-ui-fabric-react/lib/Tooltip';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { FicheIdentification } from '../Fiche/FicheIdentification';
import { FicheProgramme } from '../Fiche/FicheProgramme';
import { FicheTrancheTravaux } from '../Fiche/FicheTrancheTravaux';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';
import { DataCompte } from '../../data/DataCompte';
import { DataOperation } from '../../data/DataOperation';
import { Data } from '../../data/Data';
import { SearchBox, SpinButton, Label } from 'office-ui-fabric-react';
import { ComboBoxProduit } from '../ComboBox/ComboBoxProduit';
import { ComboBoxCycleOperation } from '../ComboBox/ComboBoxCycleOperation';
import { ComboBoxCycleCommercial } from '../ComboBox/ComboBoxCycleCommercial';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { Slider } from '@fluentui/react';
import PerimetreContext from '../../contexts/PerimetreContext';

/****************************************************************
 PROPS:

    //*********************************************************
    //Appel depuis tableau de bord
    //*********************************************************
    AppelDepuisTableauDeBord
    MasqueCommandBar
    FiltreIdStatut
    modeSelectionDeOperation => SelectionMode.none, SelectionMode.single, SelectionMode.multiple
    //*********************************************************

****************************************************************/

export class DetailsListOperation extends Component {
    static contextType = PerimetreContext;
    render = () => {
        const { perimetre } = this.context;
        return <DetailsListOperationWithPerimetre {...this.props} perimetre={perimetre} />;
    };
};

class DetailsListOperationWithPerimetre extends Component {

    static contextType = PerimetreContext;

    static defaultProps = {
        perimetre: {}
    };

    _creationContent = () => {

        let Selection = (this.props.modeSelectionDeOperation !== undefined ? this.props.modeSelectionDeOperation : SelectionMode.multiple);

        return (<DetailsList
            items={this.state.items}
            columns={this.columns}
            selectionMode={Selection}
            selection={this._selection}
            constrainMode={ConstrainMode.unconstrained}
            onColumnHeaderClick={this._onColumnHeaderClick}
            onRenderDetailsHeader={this._onRenderDetailsHeader}
        />);
    };

    constructor(props) {
        super(props);

        this._filtres = {};
        this._selection = new Selection({
            onSelectionChanged: () => this._getSelectionDetails()
        });

        this.objetState = {
            items: [],
            idProgrammeSelectionne: 0,
            idTrancheTravauxSelectionne: 0,

            //YD : ajout idRegion, idAgence
            idRegionProgramme: 0,
            idAgenceProgramme: 0,
            idRegionTrancheTravaux: 0,
            idAgenceTrancheTravaux: 0,

            idRegion: 0,
            idAgence: 0,

            selectedOperations: [],
            libelleRegroupement: null,

            tri: '',

            redirectToIdentificationProgramme: false,
            redirectToIdentificationOperation: false,

            onAffichePanelIdentification: false,
            onAfficheDialogCreerAPartirDe: false,
            afficherPanelFiltres: false,

            enCoursDeTraitement: false,
            messageEnCoursTraitement: null,

            hideMessageBarWarning: true,
            hideMessageBarError: true,
            warningMessage: '',
            errorMessage: ''
        };

        this.state = this.objetState;

        //#region chargement des columns
        let columnsTemp = [];
        columnsTemp.push({
            key: 'ids',
            name: 'IDs',
            ariaLabel: 'IDs',
            fieldName: 'ids',
            minWidth: 75,
            maxWidth: 75,
            className: 'ms-hiddenMdDown',
            headerClassName: 'ms-hiddenMdDown',
            onRender: (item) => {
                const { idProgramme, idTrancheTravaux, idOperation } = item;
                const ids = `${idProgramme || "-"}/${idTrancheTravaux || "-"}/${idOperation || "-"}`;
                return <span title={ids}>{ids}</span>;
            }
        });
        columnsTemp.push({
            key: 'programme',
            name: 'Programme',
            ariaLabel: 'Programme',
            fieldName: 'programme',
            minWidth: 150,
            maxWidth: 240,
            isResizable: true,
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            onRender: (item) => {
                const programme = item.programme;
                return <span title={programme}>{programme}</span>;
            }
        });
        columnsTemp.push({
            key: 'trancheTravaux',
            name: 'Tranche travaux',
            ariaLabel: 'Tranche travaux',
            fieldName: 'trancheTravaux',
            minWidth: 50,
            maxWidth: 80,
            isResizable: true,
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            onRender: (item) => {
                const trancheTravaux = item.trancheTravaux;
                return <span title={trancheTravaux}>{trancheTravaux}</span>;
            }
        });
        columnsTemp.push({
            key: 'produit',
            name: 'Produit',
            ariaLabel: 'Produit',
            fieldName: 'produit',
            minWidth: 75,
            maxWidth: 100,
            isResizable: true,
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            onRender: (item) => {
                const produit = item.produit;
                return <span title={produit}>{produit}</span>;
            }
        });
        columnsTemp.push({
            key: 'nomCommercial',
            name: 'Nom commercial',
            ariaLabel: 'Nom commercial',
            fieldName: 'nomCommercial',
            minWidth: 100,
            maxWidth: 400,
            isResizable: true,
            onRender: (item) => {
                let nomCommercial = item.nomCommercial;
                return <span title={nomCommercial}>{nomCommercial}</span>;
            }
        });
        columnsTemp.push({
            key: 'cycleOperation',
            name: 'Cycle opération',
            ariaLabel: 'Cycle opération',
            fieldName: 'cycleOperation',
            minWidth: 150,
            maxWidth: 180,
            isResizable: true,
            onRender: (item) => {
                let cycleOperation = item.dernierCycleOperation;
                let classBadge = Immocom.getBadgeCycleOperation(item.idDernierCycleOperation);

                return <span title={cycleOperation} className={"badge badge-" + classBadge}>{cycleOperation}</span>;
            }
        });
        columnsTemp.push({
            key: 'cycleCommercial',
            name: 'Cycle commercial',
            ariaLabel: 'Cycle commercial',
            fieldName: 'cycleCommercial',
            className: 'ms-hiddenLgDown',
            headerClassName: 'ms-hiddenLgDown',
            minWidth: 100,
            maxWidth: 120,
            isResizable: true,
            onRender: (item) => {
                let cycleCommercial = item.dernierCycleCommercial;

                return <span title={cycleCommercial} className="badge badge-secondary">{cycleCommercial}</span>;
            }
        });
        columnsTemp.push({
            key: 'nbLotsUnitairesAppartementOuMaison',
            name: 'Nb lots',
            ariaLabel: 'Nombre de lots',
            fieldName: 'nbLotsUnitairesAppartementOuMaison',
            minWidth: 60,
            maxWidth: 60,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                let nbreLots = item.nbLotsUnitairesAppartementOuMaison;
                return <span>{nbreLots}</span>;
            }
        });
        columnsTemp.push({
            key: 'nbLotsUnitairesAppartementOuMaisonALaVente',
            name: 'A la vente',
            ariaLabel: 'A la vente',
            fieldName: 'nbLotsUnitairesAppartementOuMaisonALaVente',
            minWidth: 60,
            maxWidth: 60,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                let nbreALaVente = item.nbLotsUnitairesAppartementOuMaisonALaVente;
                return <span>{nbreALaVente}</span>;
            }
        });
        columnsTemp.push({
            key: 'nbLotsUnitairesAppartementOuMaisonEnStock',
            name: 'En stock',
            ariaLabel: 'En stock',
            fieldName: 'nbLotsUnitairesAppartementOuMaisonEnStock',
            minWidth: 60,
            maxWidth: 60,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                let nbreStock = item.nbLotsUnitairesAppartementOuMaisonEnStock;
                return <span>{nbreStock}</span>;
            }
        });
        columnsTemp.push({
            key: 'nbLotsUnitairesAppartementOuMaisonOptionnes',
            name: 'Optionnés',
            ariaLabel: 'Optionnés',
            fieldName: 'nbLotsUnitairesAppartementOuMaisonOptionnes',
            minWidth: 60,
            maxWidth: 60,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                let nbreOption = item.nbLotsUnitairesAppartementOuMaisonOptionnes;
                return <span>{nbreOption}</span>;
            }
        });
        columnsTemp.push({
            key: 'nbLotsUnitairesAppartementOuMaisonReserves',
            name: 'Réservés',
            ariaLabel: 'Réservés',
            fieldName: 'nbLotsUnitairesAppartementOuMaisonReserves',
            minWidth: 60,
            maxWidth: 60,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                let nbreResa = item.nbLotsUnitairesAppartementOuMaisonReserves;
                return <span>{nbreResa}</span>;
            }
        });
        columnsTemp.push({
            key: 'engagementInitialNb',
            name: 'Engagement initial nb',
            ariaLabel: 'Engagement initial nb',
            fieldName: 'engagementInitialNb',
            minWidth: 60,
            maxWidth: 60,
            isResizable: true,
            className: 'ms-hiddenXlDown',
            headerClassName: 'ms-hiddenXlDown',
            onRender: (item) => {
                let engagementInitialNb = item.engagementInitialNb;
                return <span>{engagementInitialNb}</span>;
            }
        });

        //YD (19/05/2021): rustine pour régler la publication de la fiche programme en erreur
        //il faudra décommenter le code ci-dessous pour remettre les boutons d'accès au programme et à la tranche travaux

        columnsTemp.push({
            key: 'programme',
            name: '',
            ariaLabel: 'programme',
            fieldName: 'programme',
            minWidth: 20,
            maxWidth: 20,
            iconName: '',
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                if (item.idProgramme !== null) {
                    return <IconButton
                        iconProps={{ iconName: 'CityNext2' }}
                        title="Identification du programme"
                        ariaLabel="Identification du programme"
                        onClick={() => this._redirectToIdentificationProgramme(true, item.idRegion, item.idAgence, item.idProgramme)}
                    />;
                }
            }
        });
        columnsTemp.push({
            key: 'tranche travaux',
            name: '',
            ariaLabel: 'tranche travaux',
            fieldName: 'tranche travaux',
            minWidth: 20,
            maxWidth: 20,
            iconName: '',
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                if (item.idProgramme !== null && item.idTrancheTravaux !== null) {
                    return <IconButton
                        iconProps={{ iconName: 'ClipboardList' }}
                        title="Modifier la tranche travaux"
                        ariaLabel="Modifier la tranche travaux"
                        onClick={() => this._onAffichePanelTrancheTravaux(item.idProgramme, item.idTrancheTravaux, item.idRegionTrancheTravaux, item.idAgenceTrancheTravaux)}
                    />;
                }
            }
        });
        columnsTemp.push({
            key: 'identification',
            name: '',
            ariaLabel: 'Accéder à l\'identification',
            fieldName: 'identification',
            minWidth: 20,
            maxWidth: 20,
            iconName: '',
            isIconOnly: true,
            isSorted: false,
            onRender: (item) => {
                if (item.idOperation !== null) {
                    return <IconButton
                        iconProps={{ iconName: 'Home' }}
                        title="Identification de l'opération"
                        ariaLabel="IdentificationOperation"
                        onClick={() => this._redirectToIdentificationOperation(true, item.idRegion, item.idAgence, item.idProgramme, item.idOperation)}
                    />;
                }
            }
        });
        this.columns = columnsTemp;
        //#endregion
    };

    _appliquerFiltres = (filtres) => {
        this._filtres = { ...filtres };
        this.setState(
            { afficherPanelFiltres: false },
            this._chargementDonnees
        );
    };

    _chargementDonnees = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des opérations en cours'
        });

        let chargementOperation = DataOperation._chargementOperations(this._filtres, this.state.tri, this.props.FiltreIdStatut);

        chargementOperation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    //let listeOperations = responseFetch.reponseAPIobjet;
                    //YD : 17/06/2020 : Ajout test sur listeItem != null
                    let listeItem = (responseFetch.reponseAPIobjet !== null ? responseFetch.reponseAPIobjet : []);

                    this.setState({
                        items: listeItem,

                        enCoursDeTraitement: false,
                        hideMessageBarWarning: true,
                        warningMessage: '',
                        hideMessageBarError: true,
                        errorMessage: ''
                    });

                    this.props.majPerimetre(true);
                }
                else {
                    let stateTemp = {};
                    stateTemp.items = [];

                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    };

    _getEstAdminNational = () => {
        let chargementEstAdminNational = DataCompte._getEstAdminNational();
        chargementEstAdminNational
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const estAdminNational = responseFetch.reponseAPIobjet.estAdminNational;
                    this.setState({ estAdminNational });
                }
                else {
                    let stateTemp = {};
                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    };

    _onCreerOperationAPartirDe = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Création de l\'opération en cours'
        });

        let onEnregistrementCreerAPartirDe = DataOperation._onEnregistrementCreerAPartirDe(this.state.selectedOperations[0].idOperation);

        onEnregistrementCreerAPartirDe
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    this._onCacheDialogCreerAPartirDe();
                    this._chargementDonnees();
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    };

    _recuperationPerimetre = () => {
        var verificationSiPerimetreExiste = Data._verificationSiPerimetreExiste();

        verificationSiPerimetreExiste
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let valeurRetour = responseFetch.reponseAPIobjet;
                    let idOperation = valeurRetour[0];

                    this.setState({ idOperation: idOperation });
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    };

    _getItems = () => {
        let tableauBoutons = [];

        const rechercheRapide = {
            key: 'search',
            onRender: () => <SearchBox
                className="searchBox"
                onClear={(e) => this._onSearch('')}
                onSearch={value => this._onSearch(value)}
                placeholder="Recherche rapide"
            />
        };

        tableauBoutons.push(rechercheRapide);

        const boutonNouveauProgramme = {
            disabled: !this.state.estAdminNational, // Ticket 964
            key: 'nouveauProgramme',
            ariaLabel: 'creerProgramme',
            name: 'Créer un programme',
            iconProps: { iconName: 'Add' },
            onClick: () => this._onAffichePanelProgramme(0, 0, 0)
        }

        tableauBoutons.push(boutonNouveauProgramme);

        const boutonNouvelleTrancheTravaux = {
            disabled: !this.state.estAdminNational, // Ticket 964
            key: 'nouvelleTrancheTravaux',
            name: 'Créer une tranche travaux',
            iconProps: { iconName: 'Add' },
            onClick: () => this._onAffichePanelTrancheTravaux(0, 0, 0)
        }

        tableauBoutons.push(boutonNouvelleTrancheTravaux);

        const boutonNouvelleOperation = {
            key: 'nouvelleOperation',
            name: 'Créer Opération Commerciale',
            iconProps: { iconName: 'Add' },
            onClick: this._onAffichePanelIdentification
        }

        tableauBoutons.push(boutonNouvelleOperation);

        const boutonCreerAPartirDe = {
            key: 'creerAPartirDe',
            name: 'Créer à partir de',
            iconProps: { iconName: 'PageAdd' },
            disabled: this._selection.getSelectedCount() !== 1,
            onClick: this._onAfficheDialogCreerAPartirDe
        }

        tableauBoutons.push(boutonCreerAPartirDe);

        return tableauBoutons;
    };

    _getFarItems = () => {
        return [
            {
                key: 'nombreEnregistrement',
                name: (this.state.items != null ? this.state.items.length : 0)
            },
            {
                key: 'filtre',
                name: 'Filtres',
                iconProps: {
                    iconName: 'Filter'
                },
                iconOnly: true,
                onClick: this._togglePanelFiltres(true)
            }
        ];
    };

    _onColumnHeaderClick = (ev, column) => {
        const columns = this.columns;
        const newColumns = columns.slice();
        const currColumn = newColumns.filter(currCol => column.key === currCol.key)[0];

        newColumns.forEach((newCol) => {
            if (newCol === currColumn) {
                currColumn.isSortedDescending = !currColumn.isSortedDescending;
                currColumn.isSorted = true;
            } else {
                newCol.isSorted = false;
                newCol.isSortedDescending = false;
            }
        });

        let tri = column.key + (column.isSortedDescending ? ' DESC' : ' ASC');

        this.setState(
            { tri: tri },
            this._chargementDonnees
        );

    };

    _onRenderDetailsHeader = (props, defaultRender) => {
        return (
            <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced={true}>
                {defaultRender({
                    ...props,
                    onRenderColumnHeaderTooltip: (tooltipHostProps) => <TooltipHost {...tooltipHostProps} />
                })}
            </Sticky>
        );
    };

    _onSearch = (keyword) => {
        this._filtres.recherche = keyword;
        this._chargementDonnees();
    };

    _getSelectionDetails = () => {
        if (this._selection.getSelectedCount() > 0) {
            this.setState({
                selectedOperations: this._selection.getSelection()
            });
        }
        else {
            this.setState({
                selectedOperations: []
            });
        }
    };

    _onAffichePanelIdentification = () => {
        this.setState({ onAffichePanelIdentification: true });
    };

    _onCachePanelIdentificationEtRechargementListe = () => {
        this.setState({ onAffichePanelIdentification: false });
        this._chargementDonnees();
    };

    _onCachePanelIdentification = () => {
        this.setState({ onAffichePanelIdentification: false });
    };

    _togglePanelFiltres = (afficherPanelFiltres) => () => { this.setState({ afficherPanelFiltres }); };

    _onAffichePanelProgramme = (idProgramme, idRegion, idAgence) => {
        this.setState({
            onAffichePanelProgramme: true,
            idProgrammeSelectionne: idProgramme,
            idRegionProgramme: idRegion,
            idAgenceProgramme: idAgence
        });
    };

    _onCachePanelProgramme = (rechargerLesDonnees) => () => {
        this.setState({
            onAffichePanelProgramme: false,
            idProgrammeSelectionne: 0,
            idRegionProgramme: 0,
            idAgenceProgramme: 0
        });
        if (rechargerLesDonnees) {
            this._chargementDonnees();
            this._rechargementPerimetre();
        }
    };

    _onAffichePanelTrancheTravaux = (idProgramme, idTrancheTravaux, idRegion, idAgence) => {

        this.setState({
            onAffichePanelTrancheTravaux: true,
            idProgrammeSelectionne: idProgramme,
            idTrancheTravauxSelectionne: idTrancheTravaux,
            idRegionTrancheTravaux: idRegion,
            idAgenceTrancheTravaux: idAgence
        });
    };

    _onCachePanelTrancheTravaux = (rechargerLesDonnees) => () => {
        this.setState({
            onAffichePanelTrancheTravaux: false,
            idProgrammeSelectionne: 0,
            idTrancheTravauxSelectionne: 0,
            idRegionTrancheTravaux: 0,
            idAgenceTrancheTravaux: 0
        });
        if (rechargerLesDonnees)
            this._chargementDonnees();
    };

    _onAfficheDialogCreerAPartirDe = () => {
        this.setState({
            onAfficheDialogCreerAPartirDe: true
        });
    };

    _onCacheDialogCreerAPartirDe = () => {
        this.setState({
            onAfficheDialogCreerAPartirDe: false
        });
    };

    _redirectToIdentificationOperation = (updatePerimetre, idRegion, idAgence, idProgramme, idOperation) => {
        if (updatePerimetre) {
            const { setPerimetre } = this.context;
            const perimetre = { idRegion, idAgence, idProgramme, idOperation };
            const onSuccess = () => {
                this.setState({ redirectToIdentificationOperation: true });
                //localStorage.setItem("onSelectionneOperation", "true"); // KP - 02/01/2023 : n'est plus utilisé
            };
            const onError = (retourVerif, responseFetch) => Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            setPerimetre(perimetre, onSuccess, onError);
        }
        else {
            if (Object.keys(this._filtres).length === 0) {
                this.setState({ redirectToIdentificationOperation: true });
            }
        }
    };

    _redirectToIdentificationProgramme = (updatePerimetre, idRegion, idAgence, idProgramme) => {
        if (updatePerimetre) {
            const { setPerimetre } = this.context;
            const perimetre = { idRegion, idAgence, idProgramme, idOperation: 0 };
            const onSuccess = () => this.setState({ redirectToIdentificationProgramme: true });
            const onError = (retourVerif, responseFetch) => Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
            setPerimetre(perimetre, onSuccess, onError);
        }
        else {
            this.setState({ redirectToIdentificationProgramme: true });
        }
    };

    _rechargementPerimetre = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Rechargement du périmètre en cours'
        });

        let rechargementDeMonCompte = Data._onRechargementDeMonCompte();

        rechargementDeMonCompte
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {

                }
                else {
                }
            });
    }

    componentDidMount = () => {
        this._chargementDonnees();
        this._getEstAdminNational();
    };

    //componentDidUpdate = (prevProps, prevState) => {
    //    if (localStorage.getItem("onRecharge") === "true") {
    //        localStorage.setItem("onRecharge", "false");

    //        this._chargementDonnees();
    //        this._recuperationPerimetre();
    //    }

    //    if (!!this.state.idOperation && this.state.idOperation !== prevState.idOperation)
    //        this._redirectToIdentificationOperation(false);
    //};

    componentDidUpdate = (prevProps, prevState) => {
        const { perimetre } = this.props;
        if (JSON.stringify(prevProps.perimetre) !== JSON.stringify(perimetre)) {
            this._chargementDonnees();
            this._recuperationPerimetre();
        }

        if (!!this.state.idOperation && this.state.idOperation !== prevState.idOperation)
            this._redirectToIdentificationOperation(false);
    };

    render = () => {

        const { redirectToIdentificationOperation, redirectToIdentificationProgramme } = this.state;
        const content = this._creationContent();

        if (redirectToIdentificationProgramme) return <Redirect to="/Operations/IdentificationProgramme" />;
        if (redirectToIdentificationOperation) return <Redirect to="/Operations/IdentificationOperation" />;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                {this.props.MasqueCommandBar === undefined ?
                    <CommandBar
                        items={this._getItems()}
                        overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                        farItems={this._getFarItems()}
                        ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                    />
                    : null
                }
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />

                {this.props.AppelDepuisTableauDeBord ? content :
                    <div className="position-relative h-100">
                        <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                            {content}
                        </ScrollablePane>
                    </div>
                }
            </Stack>

            <PanelFiltres
                idCycleCommercial={this._filtres.idCycleCommercial}
                idCycleOperation={this._filtres.idCycleOperation}
                idProduit={this._filtres.idProduit}
                isOpen={this.state.afficherPanelFiltres}
                nbLotsMax={this._filtres.nbLotsMax}
                nbLotsMin={this._filtres.nbLotsMin}
                engagementInitialNb={this._filtres.engagementInitialNb}
                engagementInitialCAMin={this._filtres.engagementInitialCAMin}
                engagementInitialCAMax={this._filtres.engagementInitialCAMax}
                onDismiss={this._togglePanelFiltres(false)}
                onValidation={(filtres) => this._appliquerFiltres(filtres)}
            />

            <FicheIdentification
                onAffichePanelIdentification={this.state.onAffichePanelIdentification}
                onAnnuleFiche={this._onCachePanelIdentification}
                onEnregistrementFiche={this._onCachePanelIdentificationEtRechargementListe}
                estCreation={true}
            />

            <FicheProgramme
                isOpen={this.state.onAffichePanelProgramme}
                onAnnulation={this._onCachePanelProgramme(false)}
                onEnregistrement={this._onCachePanelProgramme(true)}
                idProgramme={this.state.idProgrammeSelectionne}
                idRegion={this.state.idRegionProgramme}
                idAgence={this.state.idAgenceProgramme}
            />

            <FicheTrancheTravaux
                isOpen={this.state.onAffichePanelTrancheTravaux}
                onAnnulation={this._onCachePanelTrancheTravaux(false)}
                onEnregistrement={this._onCachePanelTrancheTravaux(true)}
                idProgramme={this.state.idProgrammeSelectionne}
                idTrancheTravaux={this.state.idTrancheTravauxSelectionne}
                idRegion={this.state.idRegionTrancheTravaux}
                idAgence={this.state.idAgenceTrancheTravaux}
            />

            <Dialog
                hidden={!this.state.onAfficheDialogCreerAPartirDe}
                onDismiss={this._onCacheDialogCreerAPartirDe}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: 'Créer une opération à partir de',
                    subText: `Etes-vous certain de vouloir CREER une nouvelle opération à partir de l'opération ${(this.state.selectedOperations.length > 0 ? this.state.selectedOperations[0].nomOperation : null)} ?`
                }}
                modalProps={{
                    isBlocking: true,
                    styles: { main: { maxWidth: 450 } }
                }}
            >
                <DialogFooter>
                    <PrimaryButton onClick={this._onCreerOperationAPartirDe} text="Valider" />
                    <DefaultButton onClick={this._onCacheDialogCreerAPartirDe} text="Annuler" />
                </DialogFooter>
            </Dialog>

        </Fragment>;

    };

}

class PanelFiltres extends Component {

    /*
    ******************************************************************************************************
    PROPS :
        ATTRIBUTS :
            bool    isOpen                              détermine si panel ouvert ou non
            number  idCycleOperation                    id du cycle de l'opération
            number  idProduit                           id du type de produit
            number  nbLotsMin                           quantité minimal de lots
            number  nbLotsMax                           quantité maximale de lots
            number  engagementInitialCAMin              quantité minimal de CA en HT
            number  engagementInitialCAMax              quantité maximale de CA en HT
        METHODES :
            void    onDismiss                           méthode appelée lorsque l'utilisateur clique sur "Annuler"
            void    onValidation(filtres)               méthode appelée lorsque l'utilisateur clique sur "Valider"
    ******************************************************************************************************
    */

    constructor(props) {
        super(props);
        this.state = {};
    };

    _appliquerFiltres = () => {
        const filtres = {
            idCycleCommercial: this.state.idCycleCommercial,
            idCycleOperation: this.state.idCycleOperation,
            idProduit: this.state.idProduit,
            nbLotsMin: this.state.nbLotsMin,
            nbLotsMax: this.state.nbLotsMax,
            engagementInitialNb: this.state.engagementInitialNb,
            engagementInitialCAMin: this.state.engagementInitialCAMin,
            engagementInitialCAMax: this.state.engagementInitialCAMax,
        };
        this.props.onValidation(filtres);
    };

    _reinitialiserFiltres = () => {
        this.setState({ ...PanelFiltres.defaultProps });
    };

    _onOpen = () => {
        this.setState({
            idCycleCommercial: this.props.idCycleCommercial,
            idCycleOperation: this.props.idCycleOperation,
            idProduit: this.props.idProduit,
            nbLotsMin: this.props.nbLotsMin,
            nbLotsMax: this.props.nbLotsMax,
            engagementInitialNb: this.props.engagementInitialNb,
            engagementInitialCAMin: this.props.engagementInitialCAMin,
            engagementInitialCAMax: this.props.engagementInitialCAMax,
        });
    };

    _onRenderFooterContent = () => {
        return <Stack horizontal gap="8px">
            <PrimaryButton name="btnValider" onClick={this._appliquerFiltres} >Valider</PrimaryButton>
            <DefaultButton onClick={this.props.onDismiss}>Fermer</DefaultButton>
        </Stack>;
    };

    _onchangeLotSlider = (_, [val1, val2]) => {
        this.setState({
            nbLotsMin: val1,
            nbLotsMax: val2
        });
    }

    _onchangeCASlider = (_, [val1, val2]) => {
        this.setState({
            engagementInitialCAMin: val1 * 1000,
            engagementInitialCAMax: val2 * 1000
        });
    }

    render = () => {

        return <Panel
            closeButtonAriaLabel="Fermer"
            headerText="Filtres"
            isOpen={this.props.isOpen}
            onDismiss={this.props.onDismiss}
            onOpen={() => this._onOpen()}
            onRenderFooterContent={this._onRenderFooterContent}
            type={PanelType.smallFixedFar}
        >
            <Stack>

                <Stack horizontal reversed>
                    <IconButton
                        iconProps={{ iconName: 'ClearFilter' }}
                        className="buttonFiltres"
                        title="Réinitialiser les filtres"
                        ariaLabel="Filtres"
                        onClick={this._reinitialiserFiltres}
                    />
                </Stack>

                <ComboBoxProduit
                    data-testid="comboProduit"
                    onChange={(event, option) => this.setState({ idProduit: option.key })}
                    selectedKey={this.state.idProduit}
                />

                <ComboBoxCycleOperation
                    onChange={(event, option, index, value, item) => this.setState({ idCycleOperation: option.key })}
                    selectedKey={this.state.idCycleOperation}
                />

                <ComboBoxCycleCommercial
                    onChange={(event, option) => this.setState({ idCycleCommercial: option.key })}
                    selectedKey={this.state.idCycleCommercial}
                />

                <TextField // Note KP : TextFieldNombre en cours de test
                    label="Engagement Initial Nb."
                    value={this.state.engagementInitialNb}
                    onBlur={e => this.setState({ engagementInitialNb: e.target.value === '' ? 0 : e.target.value })}
                />

                <Slider
                    ranged
                    styles={sliderStyles}
                    label="Engagement initial CA. (en k€)"
                    step={1000}
                    min={0}
                    max={999999}
                    defaultValue={this.state.engagementInitialCAMax / 1000}
                    defaultLowerValue={this.state.engagementInitialCAMin / 1000}
                    onChange={this._onchangeCASlider}
                />

                <Slider
                    ranged
                    styles={sliderStyles}
                    label="Engagement(nbre de lots)"
                    min={0}
                    max={500}
                    defaultValue={this.state.nbLotsMax}
                    defaultLowerValue={this.state.nbLotsMin}
                    onChange={this._onchangeLotSlider}
                />
            </Stack>
        </Panel>;

    };

};

const sliderStyles = {
    titleLabel: {
        fontWeight: 400,
        padding: '5px 0px'
    },
    valueLabel: {
        fontWeight: 400
    },
    inactiveSection: {
        background: '#d3d3d3'
    }
}

PanelFiltres.propTypes = {
    idProduit: PropTypes.number,
    idCycleCommercial: PropTypes.number,
    idCycleOperation: PropTypes.number,
    nbLotsMin: PropTypes.number,
    nbLotsMax: PropTypes.number,
    engagementInitialNb: PropTypes.number,
    engagementInitialCAMin: PropTypes.number,
    engagementInitialCAMax: PropTypes.number,
    isOpen: PropTypes.bool.isRequired,
    onValidation: PropTypes.func.isRequired,
    onDismiss: PropTypes.func.isRequired,
};

PanelFiltres.defaultProps = {
    idCycleCommercial: 0,
    idCycleOperation: 0,
    idProduit: 0,
    nbLotsMin: 0,
    nbLotsMax: 999,
    engagementInitialNb: 0,
    engagementInitialCAMin: 0,
    engagementInitialCAMax: 999999999,
};